<template>
    <div>
        <TextBanner>
            Nach der Katastrophe wird innerhalb weniger Monate eine <strong>Schutzhülle aus Beton</strong> um den ukrainischen
            Unglücksreaktor 4 gebaut. Diese soll die radioaktiven Stoffe und Strahlung einschließen wie ein <strong>Sarkophag</strong>.
        </TextBanner>

        <InfoBox modalName="HotspotBetonsarkophag">
            <template #title>Radioaktive Strahlung</template>
            <template #subline></template>
            <template>
                <p> Durch den Unfall gelangen in den folgenden Tagen große Mengen an <strong>radioaktiven Stoffen</strong> in die Atmosphäre.
                    Für Menschen sind insbesondere das radioaktive <strong>Cäsium</strong> (Cäsium-137 und Cäsium-134) und <strong>Jod</strong> (Jod-131) gefährlich.
                    Hochdosiert führt radioaktive Strahlung zu <strong>Verbrennungen der Haut</strong>, zur Zerstörung des <strong>Nervensystems</strong> und sie verursacht verschiedene <strong>Krebserkrankungen</strong>.                    
                     <strong></strong> </p>
            </template>
        </InfoBox>
        
        <Fallback>
            <picture>
                <source media="(orientation: portrait)" srcset="../assets/img/fallback/05_Betonsarkophag_iPad_P.jpg">
                <source media="(orientation: landscape)" srcset="../assets/img/fallback/05_Betonsarkophag_iPad_L.jpg">
                <!-- The img element is required as the last child tag of the picture declaration block. The img element is used to provide backward compatibility for browsers that do not support the picture element, or if none of the source tags matched. -->
                <img src="../assets/img/fallback/Infobox.png" alt="">
            </picture>          
            <div class="hotspot" v-on:click="infobox('HotspotBetonsarkophag')"></div>	
        </Fallback>

    </div>
</template>

<script>
    export default {
        name: 'Betonsarkophag',
        babylonState: {
            moveCamera: [-7.2, 1.4, 8, 13.5, 1.6, 0],            
            hotspot: {
                visible: true,
                infoBox: 'HotspotBetonsarkophag', // Muss zur Infobox oben passen!
                position: [15, 3, -1],
                scale: 2,
                //scale: 0,

            },

            Geo_Tschernobyl: {

                children: {

                    BG_Sphere: true,
                    
                    Strahl_1: false,
                    Strahl_2: false,
                    Geo_Beton_Sarkophag: true,
                    Geo_Schattenplane_Betonsarkophag: true,
                    Geo_Textur1_Reaktor_4_Damage: false,
                    Geo_Textur1_Reaktor_4_Damage_Aussen: false,
                    Geo_Textur1_Reaktor_4_Damage_Innen: false,
                    

                },

            },

            fire: false
        },

        babylonReady: function () {
            //this.$audioController.initTrack('speaker', require('./../assets/audio/Uebergang_01.mp3'), false, true);

            //this.$babylonController.startAnimation("Explosion_SkaleOut",false,1),  
            
            this.$babylonController.setClipping(0.1, 20000);

            this.$babylonController.setAutoRotateBehaviour(false),
            this.$babylonController.setCameraRadiusLimit (5,110),
            this.$babylonController.zoomCamera(1.5)
            
        },

    }
</script>

<style scoped lang="scss">

    .fallback-container .hotspot {
        
        left: 65vw;
        top: 40vh;

        @media (orientation: landscape) {
            left: 60vw;
            top: 35vh;
            transform: scale(0.75);            
        }
    }


</style>
